import { FC } from 'react'
import { Tabs } from 'antd'
import { TabsProps } from 'antd/lib'
import styled from 'styled-components'
import PageLayout from '../../../components/page-layout/page-layout'
import FlexoFormsTable from './components/flexo-forms-table/flexo-forms-table'
import useRouteTab from '../../../hooks/use-route-tab'
import { dynamicRoutes } from '../../../constants/routes'
import HelpDrawer from './components/help-drawer/help-drawer'

const TabsStyled = styled(Tabs)`
    .ant-tabs-content {
        height: 100% !important;
    }
    .ant-tabs-tabpane.ant-tabs-tabpane-active {
        height: 100% !important;
        display: flex;
        flex-direction: column;
    }
`

const TabsData: TabsProps['items'] = [
    {
        label: `Ожидаемые`,
        key: 'expected',
        children: <FlexoFormsTable tab='Ожидаемые' />,
    },
    {
        label: `Завершенные`,
        key: 'completed',
        children: <FlexoFormsTable tab='Завершенные' />,
    },
]

const tabs = ['expected', 'completed'] as const

interface FlexoFormsPageProps {}

const FlexoFormsPage: FC<FlexoFormsPageProps> = () => {
    const { activeKey, onTabChange } = useRouteTab({
        tabs,
        defaultTab: 'expected',
        getRoute: dynamicRoutes.receiptsFlexoFormsTab,
    })

    return (
        <PageLayout title={'Приход флексоформ'} beforeUser={<HelpDrawer />}>
            <TabsStyled
                activeKey={activeKey}
                onChange={onTabChange}
                type='card'
                size={'large'}
                items={TabsData}
                style={{ flex: '1 1' }}
            />
        </PageLayout>
    )
}

export default FlexoFormsPage